var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { TabButton } from "./TabButton";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: 40,
        display: 'flex',
        border: "solid " + theme.palette.primary.main + " " + theme.shape.borderWidth.normal + "px ",
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
    },
    disabledBorder: {
        borderColor: theme.palette.light.action.disabled,
    },
}); }, { name: 'SnTabButtonGroup' });
/**
 * タブ選択ボタングループ
 */
export var TabButtonGroup = function (props) {
    var _a;
    var _b;
    var value = props.value, defaultValue = props.defaultValue, disabled = props.disabled, tabs = props.tabs, width = props.width, onChange = props.onChange, className = props.className, style = props.style;
    var classes = useStyles(props);
    var _c = useState(defaultValue), selectedId = _c[0], setSelectedId = _c[1];
    var handleClickItem = useCallback(function (id) {
        setSelectedId(id);
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    }, [onChange]);
    var tabButtonGroupStyle = useMemo(function () {
        return __assign({ width: width }, style);
    }, [width, style]);
    if (tabs == null || tabs.length === 0)
        return null;
    var displaySelectedId = (_b = value !== null && value !== void 0 ? value : selectedId) !== null && _b !== void 0 ? _b : tabs[0].id;
    var rootClassName = classNames((_a = {},
        _a[classes.root] = true,
        _a[classes.disabledBorder] = disabled,
        _a), className);
    return (React.createElement("div", { className: rootClassName, style: tabButtonGroupStyle }, tabs.map(function (item, index) {
        return (React.createElement(TabButton, { key: item.id, id: item.id, name: item.name, onClick: handleClickItem, disabled: disabled, selected: item.id === displaySelectedId, first: index === 0, last: index === tabs.length - 1 }));
    })));
};
